var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#9381FF",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12 18.7333 12.6 19.3333 13.3333 19.3333C14.0667 19.3333 14.6667 18.7333 14.6667 18C14.6667 17.2666 14.0667 16.6666 13.3333 16.6666C12.6 16.6666 12 17.2666 12 18ZM21.3333 18C21.3333 18.7333 21.9333 19.3333 22.6667 19.3333C23.4 19.3333 24 18.7333 24 18C24 17.2666 23.4 16.6666 22.6667 16.6666C21.9333 16.6666 21.3333 17.2666 21.3333 18ZM16.6667 18C16.6667 18.7333 17.2667 19.3333 18 19.3333C18.7333 19.3333 19.3333 18.7333 19.3333 18C19.3333 17.2666 18.7333 16.6666 18 16.6666C17.2667 16.6666 16.6667 17.2666 16.6667 18Z",
    fill: "#9381FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.088eae55a43820ff99e3832952a15a98.svg";
export { ForwardRef as ReactComponent };